import { Box, Button, CircularProgress, Dialog, Grid, IconButton, Typography } from '@mui/material';
import { MFSubmitButton, MFTextField } from '../../lib/formik';
import { Formik, useFormikContext } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import {
  Distributor,
  getDistributors,
  getDistributorsForSubdistributor,
  getDistributorsResponse,
  getRMsList,
  SubDistributor,
} from '../../redux-store/actions';
import React, { useEffect, useState } from 'react';
import { RootStateType } from '../../redux-store/reducers';
import { updateApplication } from '../../redux-store/actions/application';
import { useHistory } from 'react-router';
import {
  AMC_APPROVER_CHECK_FOR_INDIVIDUAL,
  distributorRmNameStartDate,
  USER_ROLES,
  subdistributorTypes,
  POA_AUTHORIZED_SIGNATORY_INDIVIDUAL_FLOW_VISIBLITY_ENABLE,
  POA_Authorized_signatory_can_Esign_Enable,
  poaValidationDate,
} from '../../utils/constant';

import { InfoDialog, Notes, SubHeading } from './components';
import UseRadioGroup from '../../lib/formik/Radio';
import { distributorsValidationSchema } from '../../utils/schema';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import {
  applicationComparison,
  applyRoleBasedStatus,
  checkIfApplicationIsIndividualPOA,
  checkValidationBasedOnDate,
  statusRoleBased,
  checkSupportLogin,
  checkSubDisDisable,
  ifPushToXalt,
  getOlderDate,
} from '../../utils/utilityFunctions';
import { SearchableSelect } from '../../lib/formik/searchSelectField';
import { ConfirmationDialog } from '../commonComponents';
import lodash from 'lodash';
import { getFunds } from '../../redux-store/actions/funds';
import { SubDistributorListType, SupportRmProp } from '../../redux-store/types/api-types';
import { getDistributorRMbyId } from '../../redux-store/actions/userManagement';
import { FundProps } from '../../redux-store/types/funds';
import { ApplicationProps, POAAuthorisedSignatories } from '../../redux-store/types/api-types';
import { POAAuthorisedSignatoriesFragment } from '../NonIndividualInvestor/Authorised';
import { showError } from '../../redux-store/actions/auth';
import { useFeatureToggles } from '../../utils/useDataMdms';

type DistributorDetailsProps = {
  distributorARNCodeFromAdmin: string | null;
  distributorId: number | null;
  loginType: string;
  firstName: string;
  empCode: string;
  email: string;
  subdistributorId: number | null;
  subDisCode: string | null;
  subdistributorEmail: string | null;
  supportDistributorEmail: string | null;
  supportDistributorCode: string | null;
  supportSubdistributorId: string | null | number;
  filledBy: string | null;
  distributorName: string;
  distributorArnCode: string;
  distributorRmName: string;
  distributorType: string;
  aifRmName: string | null;
};

type POAApplication = {
  authorisedSignatories: POAAuthorisedSignatories[];
  thrashold: number;
};

function GridItem({ children }: { children: React.ReactNode }) {
  return (
    <Grid item xs={12} sm={6}>
      {children}
    </Grid>
  );
}

const RMDetail = ({ createdAt }: { createdAt: string }) => {
  // const { createdAt = '' } = application || {};
  const { toggler } = useFeatureToggles();
  return (
    <>
      <GridItem>
        <MFTextField name="firstName" label="RM Name" placeholder="Enter RM name" disabled={true} />
      </GridItem>
      <GridItem>
        <MFTextField
          name="email"
          label="RM Email ID"
          placeholder="Enter RM Email ID"
          disabled={true}
        />
      </GridItem>
      {checkValidationBasedOnDate(
        createdAt || '',
        toggler.dateFeatureToggles.filledBy_validation_date,
      ) && (
        <GridItem>
          <MFTextField name="aifRmName" label="AIF RM Name *" placeholder="Enter AIF RM Name" />
        </GridItem>
      )}
      {/* <GridItem>
        <MFTextField
          name="empCode"
          label="Employee Code"
          placeholder="Enter Employee Code"
          disabled={true}
        />
      </GridItem> */}
    </>
  );
};

const DistributorDetail = ({
  distributors,
  values,
  selectedDistributor,
  setSelectedDistributor,
  selectSupport,
  setSelectSupport,
  authorisedSignatoriesPOA,
  setAuthorisedSignatoriesPOA,
}: {
  distributors: Distributor[];
  values: DistributorDetailsProps;
  selectedDistributor: SubDistributor[];
  setSelectedDistributor: (distributor: SubDistributor[]) => void;
  selectSupport: SubDistributor[];
  setSelectSupport: (distributor: SubDistributor[]) => void;
  authorisedSignatoriesPOA: POAApplication;
  setAuthorisedSignatoriesPOA: (e: POAApplication) => void;
}): JSX.Element => {
  const { role } = useSelector((store: RootStateType) => store.auth);
  const { application } = useSelector((store: RootStateType) => store.application);
  const { setValues } = useFormikContext();
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const { auth } = useSelector((store: RootStateType) => store);
  const [openDialog, setDialog] = useState(false);
  const { createdAt = '' } = application || {};
  const [loading, setLoading] = useState(false);
  const { toggler } = useFeatureToggles();
  const { poaValidationDate = '' } = toggler?.dateFeatureToggles || {};

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleDialogOpen = () => {
    setDialog(true);
  };
  const handleDialogClose = () => {
    setDialog(false);
  };

  return (
    <>
      {[USER_ROLES.RM, USER_ROLES.AMC_ADMIN].includes(role) && (
        <Grid item xs={12}>
          <UseRadioGroup
            formLabel=""
            name={`distributorType`}
            items={[
              { label: 'Existing Distributor', value: 'existing' },
              { label: 'New Distributor(Without Login)', value: 'new' },
            ]}
            disabled={auth.id != application?.createdBy || !!application?.isTopup}
          />
        </Grid>
      )}
      {values.distributorType === 'existing' ? (
        distributors.length > 0 ? (
          <>
            {[USER_ROLES.RM, USER_ROLES.AMC_ADMIN].includes(role) &&
              values.distributorId &&
              !!application?.isTopup && (
                <Grid item xs={12} sx={{ textAlign: 'right' }}>
                  <Button
                    variant="contained"
                    sx={{
                      color: 'white',
                      fontWeight: 500,
                      fontSize: 14,
                      py: 0.5,
                      px: 3,
                    }}
                    onClick={handleDialogOpen}>
                    clear
                  </Button>
                </Grid>
              )}
            <GridItem>
              <SearchableSelect
                name="distributorId"
                label={role == USER_ROLES.RM ? "Distributor's Name*" : 'Distributor Name *'}
                items={distributors
                  .sort((distributor1, distributor2) =>
                    (distributor1['name'] || '')
                      .toString()
                      .localeCompare((distributor2['name'] || '').toString()),
                  )
                  .map((item) => ({
                    key: item.name || 'NA',
                    // + ' - ' + (item.arnCode || 'NA'),
                    value: item.id,
                  }))}
                renderValuePosition={0}
                onChange={({ target: { value } }) => {
                  const distributorCode = distributors.find(
                    (item) => Number(item.id) === Number(value),
                  );
                  const { id = null, arnCode } = distributorCode || {};
                  setValues({
                    ...values,
                    distributorARNCodeFromAdmin: arnCode || 'NA',
                    distributorId: id,
                    subdistributorId: null,
                    subDisCode: null,
                    subdistributorEmail: null,
                    supportDistributorEmail: '',
                    supportDistributorCode: '',
                    supportSubdistributorId: null,
                  });
                  setSelectedDistributor(
                    distributors
                      ?.find((distributor) => distributor.id === value)
                      ?.subdistributors?.filter(
                        (ele) =>
                          subdistributorTypes[ele.subdistributorType || ''] ===
                          subdistributorTypes.direct,
                      ) || [],
                  );
                  setSelectSupport(
                    distributors
                      ?.find((distributor) => distributor.id === value)
                      ?.subdistributors?.filter(
                        (ele) =>
                          subdistributorTypes[ele.subdistributorType || ''] ===
                          subdistributorTypes.support,
                      ) || [],
                  );
                }}
                disabled={
                  [
                    USER_ROLES.DISTRIBUTOR,
                    USER_ROLES.INVESTOR,
                    USER_ROLES.POAAPPROVER,
                    USER_ROLES.SUBDISTRIBUTOR,
                    USER_ROLES.AMCAPPROVER,
                    USER_ROLES.RTAAPPROVER,
                    USER_ROLES.AMC_ADMIN,
                  ].includes(role) ||
                  auth.id != application?.createdBy ||
                  !!application?.isTopup
                }
                applyRenderValue={true}
                searchFieldPlaceholder={'Search Distributor'}
              />
              {loading && (
                <Box sx={{ display: 'flex' }}>
                  <CircularProgress size={30} />
                </Box>
              )}
            </GridItem>
            <GridItem>
              <MFTextField
                name="distributorARNCodeFromAdmin"
                label={
                  role == USER_ROLES.RM ? "Distributor's ARN Code *" : 'Distributor ARN Code *'
                }
                placeholder="Enter Distributor Code"
                disabled={true}
              />
            </GridItem>
            {!!selectedDistributor?.length && (
              <>
                <GridItem>
                  <SearchableSelect
                    name="subdistributorId"
                    label="Distributor's RM Name*"
                    items={selectedDistributor
                      .sort((subDistributor1, subDistributor2) =>
                        (subDistributor1.user['firstName'] || '')
                          .toString()
                          .localeCompare((subDistributor2.user['firstName'] || '').toString()),
                      )
                      .map((item) => ({
                        key: item.user.firstName || 'NA',
                        //  + ' - ' + (item.distributors_RM_Code || 'NA'),
                        value: item.id,
                      }))}
                    renderValuePosition={0}
                    onChange={async ({ target: { value } }) => {
                      try {
                        setLoading(true);
                        const user = selectedDistributor.find(
                          (item) => Number(item.id) === Number(value),
                        );
                        setValues({
                          ...values,
                          subdistributorId: user?.id,
                          subDisCode: user?.distributors_RM_Code || 'NA',
                          subdistributorEmail: user?.user?.email || '',
                          subdistributorPhone: user?.user?.phone || '',
                        });
                        setLoading(false);
                      } catch (e: unknown) {
                        setLoading(false);
                        console.error((e as Error).message);
                      }
                    }}
                    applyRenderValue={true}
                    disabled={
                      checkSubDisDisable(
                        role,
                        auth.id || '',
                        application?.supportSubdistributor?.user?.id || '',
                      ) ||
                      (auth.id == application?.createdBy &&
                        application?.subDistributor?.userId === auth.id) ||
                      auth.id != application?.createdBy ||
                      !!application?.isTopup
                    }
                    searchFieldPlaceholder={"Search Distributor's RM"}
                  />
                </GridItem>
                <GridItem>
                  <MFTextField
                    name="subDisCode"
                    label="Distributor's RM Code *"
                    placeholder="Enter Distributor's RM Code"
                    disabled={true}
                  />
                </GridItem>
                <GridItem>
                  <MFTextField
                    name="subdistributorEmail"
                    label="Distributor's RM Email *"
                    placeholder="Enter Distributor email"
                    disabled={true}
                  />
                </GridItem>
              </>
            )}
            {!!selectSupport?.length && (
              <>
                <GridItem>
                  <SearchableSelect
                    name="supportSubdistributorId"
                    label="CSE Name *"
                    items={selectSupport
                      ?.sort((support1, support2) =>
                        (support1.user['firstName'] || 'NA')
                          ?.toString()
                          .localeCompare((support2.user['firstName'] || '').toString()),
                      )
                      ?.map((item) => ({
                        key: item?.user?.firstName || 'NA',
                        value: item?.id || '',
                      }))}
                    searchFieldPlaceholder={'Search CSE Name'}
                    onChange={async ({ target: { value } }) => {
                      try {
                        setLoading(true);
                        const user = selectSupport.find(
                          (item) => Number(item.id) === Number(value),
                        );
                        setValues({
                          ...values,
                          supportSubdistributorId: user?.id,
                          // subDisCode: user?.user?.firstName || '',
                          supportDistributorEmail: user?.user?.email || '',
                          supportDistributorCode: user?.distributors_RM_Code || 'NA',
                        });
                        setLoading(false);
                      } catch (e: unknown) {
                        setLoading(false);
                        console.error((e as Error).message);
                      }
                    }}
                    disabled={
                      (auth.id == application?.createdBy &&
                        application?.supportSubdistributor?.userId === auth.id) ||
                      auth.id != application?.createdBy ||
                      !!application?.isTopup
                    }
                    // disabled={true}
                  />
                </GridItem>
                <GridItem>
                  <MFTextField
                    name="supportDistributorCode"
                    label="CSE Code *"
                    placeholder="Enter CSE Code"
                    disabled={true}
                  />
                </GridItem>
                <GridItem>
                  <MFTextField
                    name="supportDistributorEmail"
                    label="CSE Email *"
                    placeholder="Enter CSE Email"
                    disabled={true}
                  />
                </GridItem>
              </>
            )}
            <GridItem>
              <Box sx={{ position: 'relative' }}>
                <MFTextField
                  name="filledBy"
                  label={`Filled by ${
                    checkValidationBasedOnDate(
                      application?.createdAt || '',
                      toggler.dateFeatureToggles.filledBy_validation_date,
                    )
                      ? '*'
                      : ''
                  }`}
                  placeholder="Enter filled by"
                />
                <InfoOutlinedIcon
                  color="info"
                  fontSize="small"
                  onClick={handleOpen}
                  sx={{
                    position: 'absolute',
                    top: 16, // adjust as needed to align with the label
                    left: 75,
                    cursor: 'pointer',
                  }}
                />
              </Box>
              <InfoDialog
                onClose={handleClose}
                open={open}
                content={'Please add the Name of the Subdistributor RM.'}
              />
            </GridItem>
            {checkValidationBasedOnDate(
              application?.createdAt || '',
              toggler.dateFeatureToggles.filledBy_validation_date,
            ) && (
              <GridItem>
                <MFTextField
                  name="aifRmName"
                  label="AIF RM Name *"
                  placeholder="Enter AIF RM Name "
                />
              </GridItem>
            )}
            {application &&
              application?.poaauthorisedsignatories?.length >= 0 &&
              checkValidationBasedOnDate(application.createdAt || '', poaValidationDate) &&
              checkIfApplicationIsIndividualPOA(application) &&
              POA_AUTHORIZED_SIGNATORY_INDIVIDUAL_FLOW_VISIBLITY_ENABLE && (
                <>
                  <SubHeading>Authorised Signatories</SubHeading>
                  <POAAuthorisedSignatoriesFragment
                    onChange={(e) => setAuthorisedSignatoriesPOA(e)}
                    values={authorisedSignatoriesPOA}
                  />
                </>
              )}
          </>
        ) : (
          <Grid
            xs={12}
            sm={12}
            sx={{
              fontSize: 18,
              fontWeight: 500,
              color: 'rgb(97, 209, 214)',
              display: 'flex',
              alignItems: 'center',
              textAlign: 'center',
              justifyContent: 'center',
              mt: { lg: 9, xs: 9 },
              mb: 2.9,
              ml: { xs: 3 },
            }}>
            No distributor mapped under this RM
          </Grid>
        )
      ) : values.distributorType === 'new' ? (
        <>
          <GridItem>
            <MFTextField
              name="distributorName"
              label="Distributor Name *"
              placeholder="Enter Distributor Name"
              disabled={
                [USER_ROLES.INVESTOR, USER_ROLES.POAAPPROVER].includes(role) ||
                !!application?.isTopup
              }
            />
          </GridItem>
          <GridItem>
            <MFTextField
              name="distributorArnCode"
              label={`Distributor ARN Code ${
                ifPushToXalt(application?.pushDataTo || '') ? '*' : ''
              }`}
              placeholder="Enter Distributor ARN Code"
              disabled={
                [USER_ROLES.INVESTOR, USER_ROLES.POAAPPROVER].includes(role) ||
                !!application?.isTopup
              }
            />
          </GridItem>
          <GridItem>
            <MFTextField
              name="distributorRmName"
              label={`Distributor RM Name ${
                checkValidationBasedOnDate(createdAt, distributorRmNameStartDate) ? '*' : ''
              }`}
              placeholder="Enter Distributor RM Name"
              disabled={
                [USER_ROLES.INVESTOR, USER_ROLES.POAAPPROVER].includes(role) ||
                !!application?.isTopup
              }
            />
          </GridItem>
          {checkValidationBasedOnDate(
            application?.createdAt || '',
            toggler.dateFeatureToggles.filledBy_validation_date,
          ) && (
            <GridItem>
              <MFTextField
                name="aifRmName"
                label="AIF RM Name *"
                placeholder="Enter AIF RM Name "
              />
            </GridItem>
          )}
        </>
      ) : null}
      <ConfirmationDialog
        message={`Are you sure you want to clear RM/Distributor details ?`}
        open={openDialog}
        setOpen={handleDialogClose}
        onSave={() => {
          handleDialogClose();
          setValues({
            ...values,
            distributorARNCodeFromAdmin: '',
            distributorId: null,
            subdistributorId: null,
            subDisCode: '',
            subdistributorEmail: '',
            supportSubdistributorId: null,
            supportDistributorEmail: '',
            supportDistributorCode: '',
          });
          setSelectedDistributor([]);
          setSelectSupport([]);
        }}
        onCancel={handleDialogClose}
      />
    </>
  );
};

export default function DistributorDetails(): JSX.Element {
  const dispatch = useDispatch();
  const history = useHistory();
  const [distributors, setDistributors] = useState<Distributor[]>([]);
  const { application } = useSelector((store: RootStateType) => store.application);
  const { role } = useSelector((store: RootStateType) => store.auth);
  const [selectedDistributor, setSelectedDistributor] = useState<SubDistributor[]>([]);
  const { auth } = useSelector((store: RootStateType) => store);
  const { toggler } = useFeatureToggles();
  const { poaValidationDate = '' } = toggler?.dateFeatureToggles || {};

  const {
    distributor,
    rm,
    subdistributorId = null,
    subDistributor,
    filledBy = '',
    aifRmName = '',
    distributorArnCode = '',
    distributorName = '',
    distributorRmName = '',
    createdAt = '',
    distributorType = '',
    supportSubdistributorId = null,
    supportSubdistributor,
  } = application || {};

  const { arnCode, id } = distributor || {
    arnCode: 'NA',
    name: '',
    id: null,
  };

  const {
    empCode,
    user: { email: RMEmail = '', firstName: RMFirstName = '' },
  } = rm || { empCode: '', user: { email: '' } };

  const {
    user: { email: subdistributorEmail },
    distributors_RM_Code: subDisCode = 'NA',
  } = subDistributor || { user: { firstName: '', email: '' }, distributors_RM_Code: 'NA' };

  const { user, distributors_RM_Code = 'NA' } = supportSubdistributor || {};
  const [selectSupport, setSelectSupport] = useState<SubDistributor[]>([]);
  const initialValues: DistributorDetailsProps = {
    distributorId: id,
    distributorARNCodeFromAdmin: arnCode || 'NA',
    loginType: [USER_ROLES.DISTRIBUTOR, USER_ROLES.SUBDISTRIBUTOR].includes(role)
      ? USER_ROLES.DISTRIBUTOR
      : USER_ROLES.RM,
    empCode,
    email: RMEmail,
    firstName: RMFirstName,
    subdistributorId: subdistributorId === null ? subdistributorId : Number(subdistributorId),
    subDisCode: subDisCode || 'NA',
    subdistributorEmail,
    supportSubdistributorId:
      supportSubdistributorId === null ? supportSubdistributorId : Number(supportSubdistributorId),
    supportDistributorEmail: user?.email || '',
    supportDistributorCode: distributors_RM_Code || 'NA',
    filledBy,
    aifRmName: aifRmName,
    distributorArnCode,
    distributorName,
    distributorRmName,
    distributorType:
      distributorType ||
      ([USER_ROLES.DISTRIBUTOR, USER_ROLES.SUBDISTRIBUTOR].includes(role) ? 'existing' : ''),
  };
  const [authorisedSignatoriesPOA, setAuthorisedSignatoriesPOA] = useState<POAApplication>({
    authorisedSignatories: application?.poaauthorisedsignatories || [],
    thrashold: application?.requiredAuthorisedSignatory || 0,
  });

  useEffect(() => {
    let isComponentActive = true;
    (async function () {
      try {
        if (
          Object.keys(application || {}).length &&
          [USER_ROLES.RM, USER_ROLES.SUBDISTRIBUTOR, USER_ROLES.AMC_ADMIN].includes(role)
        ) {
          let distributors = [];
          if (USER_ROLES.RM !== role) {
            distributors = (await dispatch(
              getDistributorsForSubdistributor({
                isActive: true,
                rmId: Number(application?.rm_id),
                distributorId: Number(application?.distributor_id),
                // subdistributorType:
                //   supportSubdistributor &&
                //   checkSupportLogin(Number(auth.id), supportSubdistributor?.user.id)
                //     ? 'direct'
                //     : 'support',
              }),
            )) as unknown as Distributor[];
          } else {
            const res = (await dispatch(
              getDistributors({ isActive: true }),
            )) as unknown as getDistributorsResponse;
            distributors = res.distributors || [];
          }
          const updatedDistributor =
            (application?.distributor_id && !application.distributor.isActive) ||
            (application?.distributor_id &&
              !distributors?.map((ele) => ele.id).includes(application?.distributor_id))
              ? [
                  ...distributors,
                  {
                    ...application.distributor,
                    subdistributors: application?.subdistributorId
                      ? [application.subDistributor]
                      : application.subDistributor,
                  } as Distributor,
                ]
              : distributors;
          if (isComponentActive) {
            const updateSubdistributor = (
              application?.distributor_id &&
              application?.distributor.isActive &&
              application?.subdistributorId &&
              !application.subDistributor?.isActive
                ? [
                    ...(updatedDistributor.find(
                      (distributor) => Number(distributor.id) === Number(id),
                    )?.subdistributors || []),
                    { ...application.subDistributor },
                  ]
                : updatedDistributor.find((distributor) => Number(distributor.id) === Number(id))
                    ?.subdistributors || []
            )
              .filter((ele) => ele)
              .filter(
                (ele) =>
                  subdistributorTypes[ele.subdistributorType || ''] === subdistributorTypes.direct,
              );
            const updatedsupportSubdistributor = (
              application?.distributor_id &&
              application?.distributor.isActive &&
              application?.supportSubdistributorId &&
              !application.supportSubdistributor?.isActive
                ? [
                    ...(updatedDistributor.find(
                      (distributor) => Number(distributor.id) === Number(id),
                    )?.subdistributors || []),
                    { ...application.supportSubdistributor },
                  ]
                : updatedDistributor.find((distributor) => Number(distributor.id) === Number(id))
                    ?.subdistributors || []
            )
              .filter((ele) => ele)
              .filter(
                (ele) =>
                  subdistributorTypes[ele.subdistributorType || ''] === subdistributorTypes.support,
              );
            setSelectSupport(updatedsupportSubdistributor as unknown as SubDistributor[]);
            setSelectedDistributor(updateSubdistributor as unknown as SubDistributor[]);
            setDistributors(updatedDistributor as unknown as Distributor[]);
          }
        } else if (
          application &&
          supportSubdistributor &&
          checkSupportLogin(Number(auth.id), supportSubdistributor?.user.id)
        ) {
          const { distributor } = application || {};
          setDistributors(distributor ? [distributor as Distributor] : []);
          setSelectSupport(
            [application?.supportSubdistributor as unknown as SubDistributor].filter((ele) => ele),
          );
          const getDistributorRmDetails = (await dispatch(
            getDistributorRMbyId(Number(application?.supportSubdistributorId)),
          )) as unknown as SubDistributorListType;
          setSelectedDistributor(
            getDistributorRmDetails?.directSubdistributorsDetails
              .directSubdistributors as unknown as SubDistributor[],
          );
        } else {
          const { distributor, subDistributor } = application || {};
          setDistributors(distributor ? [distributor as Distributor] : []);
          setSelectSupport(
            [application?.supportSubdistributor as unknown as SubDistributor].filter((ele) => ele),
          );
          setSelectedDistributor(
            subDistributor
              ? [{ ...subDistributor, id: Number(subDistributor.id) } as unknown as SubDistributor]
              : [],
          );
        }
        setAuthorisedSignatoriesPOA({
          authorisedSignatories: application?.poaauthorisedsignatories || [],
          thrashold: application?.requiredAuthorisedSignatory || 0,
        });
      } catch (e: unknown) {
        console.error((e as Error).message);
      }
    })();
    return () => {
      isComponentActive = false;
    };
  }, [application?.id]);

  const onSubmit = async (values: DistributorDetailsProps) => {
    try {
      const {
        distributorId,
        subdistributorId,
        filledBy,
        aifRmName,
        distributorArnCode,
        distributorName,
        distributorRmName,
        distributorType,
        supportSubdistributorId,
      } = values;
      const {
        id,
        applicant1ReferenceId,
        currentStep = null,
        schemeId,
        planId,
        isTopup,
      } = application || {};
      const checkDistributorName =
        (!application?.distributorName && values?.distributorName) ||
        (application?.distributorName && !values?.distributorName);
      const funds = (await dispatch(
        getFunds({
          isActive: true,
          ...(values?.distributorName
            ? { isApplicableForDistributor: true }
            : { isApplicableForDirect: true }),
        }),
      )) as unknown as FundProps[];
      let schemePlan = {};
      if (funds?.length > 0) {
        const fundExists = funds?.find((fund) => Number(fund.id) === Number(schemeId));
        if (fundExists?.id && fundExists?.plans?.length > 0) {
          const planExists = fundExists?.plans?.some((plan) => Number(plan.id) === Number(planId));
          if (checkDistributorName && !planExists) {
            schemePlan = {
              schemeId: null,
              planId: null,
              commitmentAmount: 0,
              setupFeePercentage: 0,
              managementFeesRate: 0,
              taxRate: 0,
              drawDownNumber: 0,
              contributionChequeAmount: 0,
              setupFeeAmount: null,
              setupFeeGST: null,
              totalSetupFee: null,
              setupFeeTDS: null,
              netSetupFeeLessTDS: null,
              totalAmountPayable: null,
              sip: '',
              modeOfInvestment: '',
              investmentPercentage: '',
              investmentMonths: '',
              groupInvestment: null,
            };
          }
        }
      }
      if (
        application &&
        checkValidationBasedOnDate(
          getOlderDate(application?.createdAt || '', application?.applicationCreatedAt || ''),
          poaValidationDate,
        ) &&
        checkIfApplicationIsIndividualPOA(application) &&
        POA_Authorized_signatory_can_Esign_Enable &&
        POA_AUTHORIZED_SIGNATORY_INDIVIDUAL_FLOW_VISIBLITY_ENABLE
      ) {
        const getCanEsignCount = authorisedSignatoriesPOA.authorisedSignatories?.filter(
          (item) => item.canEsign,
        );
        if (!authorisedSignatoriesPOA.authorisedSignatories?.length) {
          throw 'Please add Authorised Signatories';
        }
        if (!getCanEsignCount.length) {
          throw 'Please Select a member for E-Sign';
        }
        if (getCanEsignCount.length < authorisedSignatoriesPOA.thrashold) {
          throw 'Authorised Signatories that can esign can not be less than the Total No. of required Authorised Signatories';
        }
      }

      const Poa_can_esign =
        POA_Authorized_signatory_can_Esign_Enable &&
        POA_AUTHORIZED_SIGNATORY_INDIVIDUAL_FLOW_VISIBLITY_ENABLE
          ? {
              poaauthorisedsignatories:
                application && checkIfApplicationIsIndividualPOA(application)
                  ? authorisedSignatoriesPOA.authorisedSignatories
                  : application?.poaauthorisedsignatories,
              requiredAuthorisedSignatory:
                application && checkIfApplicationIsIndividualPOA(application)
                  ? authorisedSignatoriesPOA.thrashold
                  : application?.requiredAuthorisedSignatory,
            }
          : {};

      const updatedApplication = {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        ...application!,
        ...Poa_can_esign,
        distributor_id: distributorId && distributorType === 'existing' ? distributorId : null,
        subdistributorId:
          distributorId && distributorType === 'existing'
            ? subdistributorId
              ? subdistributorId.toString()
              : subdistributorId
            : null,
        supportSubdistributorId:
          distributorId && distributorType === 'existing'
            ? supportSubdistributorId
              ? supportSubdistributorId.toString()
              : supportSubdistributorId
            : null,
        filledBy: distributorId && distributorType === 'existing' ? filledBy : null,
        distributorArnCode: distributorName && distributorType === 'new' ? distributorArnCode : '',
        distributorName: distributorName && distributorType === 'new' ? distributorName : '',
        distributorRmName: distributorName && distributorType === 'new' ? distributorRmName : '',
        distributorType:
          (distributorId && distributorType === 'existing') ||
          (distributorName && distributorType === 'new')
            ? distributorType
            : '',
        aifRmName: aifRmName || null,
      };

      const checkApplication = applicationComparison(application, {
        ...updatedApplication,
        currentStep: currentStep === null ? 1 : currentStep,
      });
      if (id && !checkApplication) {
        await dispatch(
          updateApplication({
            body: {
              ...updatedApplication,
              status: statusRoleBased(role, application),
              currentStep: 1,
              ...schemePlan,
              //currentStep === null ? 1 : currentStep
            },
            applicationId: id,
          }),
        );
        history.push(isTopup ? 'bank-details' : 'contributor-details', {
          id,
          applicant1ReferenceId,
          topUpApplication: application?.isTopup,
        });
      } else if (checkApplication) {
        history.push(isTopup ? 'bank-details' : 'contributor-details', {
          id,
          applicant1ReferenceId,
          topUpApplication: application?.isTopup,
        });
      }
    } catch (e) {
      typeof e === 'string' && dispatch(showError(e));
      console.error((e as Error).message);
    }
  };
  return (
    <Formik
      initialValues={initialValues}
      validationSchema={distributorsValidationSchema(
        selectedDistributor,
        selectSupport,
        distributors,
        createdAt,
        ifPushToXalt(application?.pushDataTo || ''),
        toggler,
      )}
      onSubmit={onSubmit}
      enableReinitialize={true}>
      {({ handleSubmit, values, errors }) => (
        <Box component="form" noValidate onSubmit={handleSubmit}>
          <Notes
            displayContent={
              'This section specifies whether the application is from an RM/Distributor’s RM.'
            }
          />
          {console.log(errors, 'erroer')}
          <Grid container rowSpacing={2} columnSpacing={5}>
            {/* Only maker can have  the edit access for fields */}
            {([USER_ROLES.RM, USER_ROLES.AMC_ADMIN].includes(role) ||
              (application?.hasPOA &&
                ![USER_ROLES.DISTRIBUTOR, USER_ROLES.SUBDISTRIBUTOR].includes(role))) && (
              <Grid item xs={12}>
                <UseRadioGroup
                  formLabel=""
                  name={`loginType`}
                  items={[
                    { label: 'Direct', value: USER_ROLES.RM },
                    { label: 'Distributor', value: USER_ROLES.DISTRIBUTOR },
                  ]}
                />
              </Grid>
            )}
            {values.loginType === USER_ROLES.RM ? (
              <RMDetail createdAt={application?.createdAt || ''} />
            ) : (
              <DistributorDetail
                distributors={distributors}
                values={values}
                selectedDistributor={selectedDistributor}
                selectSupport={selectSupport}
                setSelectSupport={setSelectSupport}
                setSelectedDistributor={(subdistributors) =>
                  setSelectedDistributor(subdistributors)
                }
                authorisedSignatoriesPOA={authorisedSignatoriesPOA}
                setAuthorisedSignatoriesPOA={(e) => setAuthorisedSignatoriesPOA(e)}
              />
            )}
          </Grid>

          <Box sx={{ width: '100%', maxWidth: '350px', mx: 'auto', mt: 5 }}>
            <MFSubmitButton label="Next" />
          </Box>
        </Box>
      )}
    </Formik>
  );
}
